// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { FileKind } from "../../../define/FileKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class GuiFeiLayer extends BasePopUpLayer {

   

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        let gameData = NormalGameManager._instance.getGameData();
        
        if (gameData.wechatRecordPoint.includes('5040Finish') && !gameData.bFinishHitRob) {
            this.openHitRobLayer();
            return;
        }
        
        if (gameData.bFinishBoastGuiFei) {
            utilsView.openEventLayer(
                null
                , {
                    id: '18'
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                    , saveData: ()=> {
                       
                    }
                    , exitLayer: ()=> {
                        this.destroyNode();
                    }
                }
                , UI_Z_INDEX.DIALOG
            );
            return;
        }

        if (gameData.bEnterBoastGuiFei) {
            this.openBoast();
        } else {
            utilsView.openEventLayer(
                null
                , {
                    id: '17'
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                    , saveData: ()=> {
                        gameData.bEnterBoastGuiFei = true;
                        NormalGameManager._instance.writeGameData();

                        this.openBoast();
                    }
                    , exitLayer: ()=> {
                        this.destroyNode();
                    }
                }
                , UI_Z_INDEX.DIALOG
            );
        }
    }

    openBoast() {
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.BoastGuiFeiLayer
            , null
            , {
                parent: this
            }
        );
    }

    openHitRobLayer() {
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.HitRobLayer
            , null
            , {
                parent: this
            }
        );
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
